var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","fillRule":"nonzero","stroke":"#000000","strokeWidth":".4","d":"M10.028 8.416L6.745 5.133l3.283-3.283A.929.929 0 0 0 8.715.537L5.432 3.82 2.149.537A.929.929 0 0 0 .836 1.85l3.283 3.283L.836 8.416A.929.929 0 0 0 2.149 9.73l3.283-3.283L8.715 9.73a.929.929 0 0 0 1.313-1.314z"}));
}

CloseIcon.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
